<template>
  <div class="articlePageBox">
    <p class="pageTitle">{{!ruleForm.id?'添加文章':'修改文章'}}</p>
    <div class="articleBox">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="发布位置">
          <el-radio-group v-model="langType" @change="setLang()">
            <el-radio label="中文版"></el-radio>
            <el-radio label="英文版"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="文章名称" prop="name" :rules="rules.blurRule">
          <el-input placeholder="请输入文章名称" v-model="ruleForm.name" class="inputW"></el-input>
        </el-form-item>
        <!-- <el-form-item label="文章来源" prop="suroce" :rules="rules.blurRule">
          <el-input placeholder="请输入文章来源" v-model="ruleForm.suroce" class="inputW"></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="上传人" prop="person" :rules="rules.blurRule">
          <el-input placeholder="请输入上传人" v-model="ruleForm.person" class="inputW"></el-input>
        </el-form-item>
        <el-form-item label="附加关键字" prop="spare1" :rules="rules.blurRule">
          <el-input placeholder="请输入附加关键字" v-model="ruleForm.spare1" class="inputW"></el-input>
        </el-form-item>
        <el-form-item label="关键字" prop="keyword" :rules="rules.blurRule">
          <el-input placeholder="请输入关键字" v-model="ruleForm.keyword" class="inputW"></el-input>
        </el-form-item> -->
        <el-form-item label="描述" prop="description" :rules="rules.blurRule">
          <el-input placeholder="请输入描述" v-model="ruleForm.description" class="inputW"></el-input>
        </el-form-item>
        <!-- <el-form-item label="排序" prop="order" :rules="rules.isIntegerRule">
          <el-input placeholder="请输入排序" v-model="ruleForm.order" class="inputW" type="number"></el-input>
        </el-form-item> -->
        <el-form-item label="图片" class="uploaderBox">
          <el-upload
            class="avatar-uploader"
            action="https://jsonplaceholder.typicode.com/posts/"
            :show-file-list="false"
            :before-upload="beforeAvatarUpload"
          >
            <img v-if="ruleForm.img" :src="ruleForm.img" class="avatar" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <!-- <el-form-item label="文章类型" prop="flag" :rules="rules.changeRule">
          <el-select class="inputW" v-model="ruleForm.flag" placeholder="请选择文章类型">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="文章分类" prop="typeId" :rules="rules.changeRule">
          <el-select class="inputW" v-model="ruleForm.typeId" placeholder="请选择文章分类">
            <el-option
              v-for="item in articleTypeOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="审核状态" prop="examine" :rules="rules.changeRule">
          <el-select class="inputW" v-model="ruleForm.examine" placeholder="请选择审核状态">
            <el-option
              v-for="item in stateOptions"
              :key="item.value"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文章内容" prop="content" :rules="rules.blurRule">
          <editor-bar v-model="ruleForm.content" :isClear="isClear" @change="change" v-if="editorIf"></editor-bar>
        </el-form-item>
      </el-form>
    </div>
    <div class="footerBox">
      <el-button type="primary" @click="onSubmit">立即提交</el-button>
      <el-button @click="cancelFunc">取消</el-button>
    </div>
  </div>
</template>

<script>
import EditorBar from "../../components/wangEditor/index";
export default {
  data() {
    var checkNum = (rule, value, callback) => {
      if (value==='') {
        return callback(new Error('输入不能为空'));
      }else {
        if (value !=parseInt(value)) {
          callback(new Error('输入必须为正数'));
        } else {
          callback();
        }
      }
    };
    return {
      isClear: false,
      detail: "",
      ruleForm: {
        id: "",
        name: "",
        suroce: "",
        person: "",
        content:"",
        flag: '0',
        spare1: "",
        keyword: "",
        description: "",
        img: "",
        typeId: "",
        order: "",
        examine: "",
        editorIf:false,
        lan: 'zh-CN'
      },
      langType: '中文版',
      rules: {
        blurRule: [
          { required: true, message: "请输入", trigger: "blur" }
        ],
        changeRule: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        // isIntegerRule:[
        //   { required: true, validator: checkNum, trigger: 'blur' }
        // ],
      },
      articleTypeOptions: [],
      typeOptions: [
        { name: "普通", value: "0" },
        { name: "推荐", value: "1" },
        { name: "热点", value: "2" }
      ],
      stateOptions: [
        { name: "待审核", value: 1 },
        { name: "已审核", value: 2 },
        { name: "发布", value: 3 },
        { name: "冻结", value: 4 }
      ],

      articleInfor:{}
    };
  },
  components: { EditorBar },
  created() {
    if (this.$route.query.id) {
      this.ruleForm.id=this.$route.query.id
      this.getArticleFunc();
    }
    this.getArticleType();
    
    this.editorIf=true
  },
  methods: {
    setLang() {
      console.log(this.langType)
      if (this.langType=='中文版') {
        this.ruleForm.lan = 'zh-CN'
      } else {
        this.ruleForm.lan = 'en-US'
      }
    },
    async getArticleFunc(){
      if(this.ruleForm.id){
        let res = await this.$http.getArticle({id:this.ruleForm.id});
        if (res) {
          this.ruleForm={...res.data}
          if (this.ruleForm.lan=='zh-CN') {
            this.langType = '中文版'
          } else {
            this.langType = '英文版'
          }
          this.ruleForm.typeId=this.ruleForm.type.id
        }
      }
    },
    cancelFunc(){
      this.$router.push({name:'copyCenterList'})
    },
    onSubmit() {
      this.$refs['ruleForm'].validate(async (valid) => {
          if (valid) {
              let res = await this.$http.addArticle({...this.ruleForm});
              if (res) {
                this.$message.success('操作成功！');
                this.$router.push({name:'copyCenterList'})
              }
          } else {
          console.log('error submit!!');
          return false;
          }
      });
    },
    async beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isLt2M) {
        this.$message.error("上传商品图片大小不能超过 20MB!");
      }
      let myform = new FormData();
      myform.append("file", file);
      let res = await this.$http.ossImg(myform);
      if (res) {
        this.ruleForm.img = res.data.src;
        this.$refs.ruleForm.validateField('img')
      }
      return false;
    },
    change(val) {
      console.log(val)
    },
    // 分类
    async getArticleType() {
      let res = await this.$http.articleTypeList({ name: "" });
      if (res) {
        this.articleTypeOptions = res.data;
      }
    }
  }
};
</script>

<style>
.footerBox{
  position: absolute;
  left: -15px;
  right: -15px;
  bottom: 0;
  display: flex;
  align-items: center;
  height: 50px;
  background: #F7F7F7;
  padding-left: 115px;
}
.inputW {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 130px;
  height: 130px;
  line-height: 130px;
  text-align: center;
}
.avatar {
  width: 130px;
  height: 130px;
  display: block;
}
.uploaderBox .el-form-item__content {
  line-height: initial;
}
.pageTitle {
  height: 44px;
  line-height: 44px;
  border-bottom: 1px solid #f6f6f6;
  margin-bottom: 20px;
  font-size: 16px;
}
</style>
